import textBlock from '@pi/text-block';
import Type from 'src/Type';
import config from 'src/utils/config';
import Primitive from 'src/utils/Primitive';

import ValueNode from '../ValueNode';

import type Context from 'src/Context';
import type { StringNodeT } from './StringNode';
import type { BaseExpression } from 'src/types';

export interface DocumentQueryNodeT extends BaseExpression {
    $type: 'DocumentQueryNode';
    model: StringNodeT;
    queryField: StringNodeT;
    queryValue: StringNodeT;
}

export default class DocumentQueryNode extends ValueNode<DocumentQueryNodeT> {
    static TYPE = Type.Object(
        {
            key: 'model',
            label: 'Model',
            type: 'StringNode',
            suggestions: 'external:DatabaseModels',
            forceSuggestion: true,
        },
        {
            key: 'queryField',
            label: 'Query Field',
            type: 'StringNode',
            suggestions: ['_id', 'gtin', 'spinsUpc'],
            forceSuggestion: true,
        },
        {
            key: 'queryValue',
            label: 'Query Value',
            type: 'StringNode',
            suggestions: 'off',
        },
    );

    static uiConfig = {
        ...config.presets.default,
        style: {
            ...config.presets.default.style,
            background: '#FFC940',
        },
        description: textBlock`
            Fetches the given model from the database
        `,
    };

    static getDefault(): any {
        return {
            ...super.getDefault(),
            model: Primitive.string('Company'),
            queryField: Primitive.string('_id'),
            queryValue: Primitive.evaluation(''),
        };
    }

    async execute(context: Context): Promise<any> {
        const model = await context.evaluate(this.expression.model);
        const queryField = await context.evaluate(this.expression.queryField);
        const queryValue = await context.evaluate(this.expression.queryValue);

        if (typeof queryValue !== 'string' || typeof model !== 'string' || !queryValue) return null;

        const query: any = { [queryField]: queryValue };

        return context.transformation.options.fetchDocumentByQuery(model, query);
    }
}
